export var SENTRY_RELEASE = "99b7b3a40adb4f9e079b817dcee9d3bb949cb7e1";
